import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { getOne } from './../../../common/v4/BackendProvider'
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import config from '../../../../config';

const Details = (props) => {
    const { invoice_id } = useParams();

    const [data, setData] = useState({totals: {voice: [], sms: [], sms_did: [], services: []}});
    const [entity, setEntity] = useState({});
    const [sms, setSms] = useState([]);

    // Helper function to format address
    const formatAddress = (address) => {
        if (!address) return null;
        
        const parts = [];
        if (address.line1) parts.push(address.line1);
        if (address.line2) parts.push(address.line2);
        
        const cityStateZip = [];
        if (address.city) cityStateZip.push(address.city);
        if (address.state) cityStateZip.push(address.state);
        if (address.zip) cityStateZip.push(address.zip);
        
        if (cityStateZip.length > 0) {
            parts.push(cityStateZip.join(', '));
        }
        
        if (address.country) parts.push(address.country);
        
        return parts.length > 0 ? parts : null;
    };

    useEffect(() => {
        loadFromServer();
    }, []);

    const loadFromServer = () => {
        getOne('/admin/reports/invoices/', invoice_id).then(
            response => {
                setData(response.data.data.invoice);
                setEntity(response.data.data.entity);
                setSms(response.data.data.sms);
            } 
        );
    }
    return (
        <div className="invoice">
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <div className="row">
                <div className="col-sm-6 invoice-left">
                    <a className="btn btn-primary btn-icon icon-print" href={`${config.usageReport.basePath}${data.pdf_path}`} target="_blank">Download PDF</a>
                </div>
                <div className="col-sm-6 invoice-right">
                    <h3><span data-l10n-id="invoice_number">Invoice number</span> {data.ATRINVNUMBER}</h3>
                    <div><strong>Type:</strong> {entity.type} Invoice</div>
                    <div><strong>Created:</strong> {data.ATRINVCREATE?.split(' ')[0]}</div>
                    <div><strong>Due:</strong> {data.ATRINVDUE?.split(' ')[0]}</div>
                    {data.ATRINVSTDT && data.ATRINVENDT && (
                        <div><strong>Billing Period:</strong> {data.ATRINVSTDT?.split(' ')[0]} to {data.ATRINVENDT?.split(' ')[0]}</div>
                    )}
                </div>
            </div>
            <hr className="margin" />
            <div className="row">
                <div className="col-lg-6 invoice-left">
                    <h4 data-l10n-id="client">Invoiced To: {entity.name} ({entity.type})</h4>                    
                    {formatAddress(entity.address) && formatAddress(entity.address).map((line, index) => (
                        <span key={index}>{line}<br/></span>
                    ))}
                    {entity.email && <><strong data-l10n-id="email">Email</strong>: {entity.email}<br/></>}
                    {entity.phone && <><strong data-l10n-id="phone">Phone</strong>: {entity.phone}<br/></>}
                    {entity.type === 'Carrier' && data.carrier?.ATRCUST3 && 
                        <><strong data-l10n-id="vat_number">VAT number</strong>: {data.carrier.ATRCUST3}<br/></>
                    }
                    {entity.type === 'Carrier' && data.carrier?.CLIENT_ID && 
                        <><strong data-l10n-id="account_number">Client ID</strong>: {data.carrier.CLIENT_ID}</>
                    }
                </div>     
            </div>
            <h4>Invoice Summary</h4>
            <table className="table table-bordered">
                <thead>
                <tr>
                    <th data-l10n-id="summary">Summary</th>
                    <th data-l10n-id="date">Date</th>
                    <th data-l10n-id="amount">Amount</th>
                </tr>
                </thead>
                <tbody>
                    <tr>
                        <td data-l10n-id="opening_balance">Opening Balance</td>
                        <td>{data.ATRINVSTDT?.split(' ')[0]}</td>
                        <td>{data.currency?.ATRCURNAME} {Number(data.ATROPENBALANCE).toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td>Total Usage and Fees</td>
                        <td>--</td>
                        <td>{data.currency?.ATRCURNAME} {Number(data.ATRINVNETAMNT).toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td>Discount {Number(data.ATRINVDISCOUNTRATE).toFixed(2)}%</td>
                        <td>--</td>
                        <td>{data.currency?.ATRCURNAME} {Number(data.ATRINVDISCOUNTAMOUNT).toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td data-l10n-id="total_payments">Total Payments</td>
                        <td>--</td>
                        <td>{data.currency?.ATRCURNAME} {Number(data.ATRPAYAMOUNT).toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td data-l10n-id="closing_balance">Closing Balance</td>
                        <td>{data.ATRINVENDT?.split(' ')[0]}</td>
                        <td>{data.currency?.ATRCURNAME} {Number(data.ATRCLOSEBALANCE).toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td><strong data-l10n-id="total_invoice">Total Invoice</strong></td>
                        <td>&nbsp;</td>
                        <td><b>{data.currency?.ATRCURNAME} {Number(data.ATRINVTOTAL).toFixed(2)}</b></td>
                    </tr>
                    <tr>
                        <td>Tax  {Number(data.ATRINVTAXRATE).toFixed(2)}%</td>
                        <td>--</td>
                        <td>{data.currency?.ATRCURNAME} {Number(data.ATRINVTAXAMNT).toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td><strong>Total Invoice with Tax</strong></td>
                        <td>&nbsp;</td>
                        <td><b>{data.currency?.ATRCURNAME} {Number(data.ATRINVTOTAL).toFixed(2)}</b></td>
                    </tr>
                </tbody>
            </table>
            {/* <h4>Voice Usage</h4>
            <VoiceTable data = {totals.voice} /> */}

           {sms && <><h4>SMS Usage</h4>
            <SmsTable sms = {sms} /></>}
{/* 
            <h4>SMS DID Recurring Fees</h4>
            <SmsDidRecurringTable data = {totals.sms_did} />

            <h4>Other Fees</h4>
            <OtherFeesTable data = {totals.services} /> */}

            {data.link_to_usage && <><h4>Usage Report</h4>
            <a href={`${config.usageReport.basePath}${data.link_to_usage}`} target="_blank">Download Usage Report</a></>}

            <div className="margin"></div>
            <div className="row">
                <div className="col-sm-12">
                    <hr/>
                </div>
            </div>
        </div>
    )
    
}


class OtherFeesTable extends React.Component {
    render(){
        return (
            <table className="table table-bordered">
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Amount</th>
                    <th>Currency</th>
                </tr>
                </thead>
                <tbody>
                {
                    this.props.data.map(function(datarow, j) {
                        return (
                            <tr key = {j}>
                                <td>{datarow.NAME}</td>
                                <td>{datarow.AMOUNT}</td>
                                <td>{datarow.CURRENCY}</td>
                            </tr>)
                    }, this)
                }
                </tbody>
            </table>
        )
    }
}

class SmsDidRecurringTable extends React.Component {
    render(){
        return (
            <table className="table table-bordered">
                <thead>
                <tr>
                    <th>Count</th>
                    <th>DID Number</th>
                    <th>Period Start</th>
                    <th>Period End</th>
                    <th>Amount</th>
                    <th>Currency</th>
                </tr>
                </thead>
                <tbody>
                {
                    this.props.data.map(function(datarow, j) {
                        return (
                            <tr key = {j}>
                                <td>{datarow.COUNT}</td>
                                <td>{datarow.DIDNUMBER}</td>
                                <td>{datarow.STARTDATE}</td>
                                <td>{datarow.ENDDATE}</td>
                                <td>{datarow.AMOUNT}</td>
                                <td>{datarow.CURRENCY}</td>
                            </tr>)
                    }, this)
                }
                </tbody>
            </table>
        )
    }
}

const SmsTable = (props) => {
    return (
        <table className="table table-bordered">
                <thead>
                <tr>
                    <th>Direction</th>
                    <th>Destination</th>
                    <th>Messages</th>
                    <th>Msg parts</th>
                    <th>Amount</th>
                    <th>Currency</th>
                </tr>
                </thead>
                <tbody>
                {
                    props.sms && props.sms?.map(function(datarow, j) {
                        var destname = datarow.ATRCLIENTDESTNAME	 || 'Unidentified'
                        return (
                            <tr key = {j}>
                                <td>{datarow.ATRDIRECTION === 'out' ?'MT' : 'MO'}</td>
                                <td>{destname}</td>
                                <td>{datarow.ATRMESSAGES}</td>
                                <td>{datarow.ATRMSGPARTS}</td>
                                <td>{datarow.ATRAMOUNT}</td>
                                <td>{datarow.currency?.ATRCURNAME}</td>
                            </tr>)
                    }, this)
                }
                </tbody>
            </table>
        )
    }


// class VoiceTable extends React.Component {
//     render(){
//         return (
//             <table className="table table-bordered">
//                 <thead>
//                 <tr>
//                     <th data-l10n-id="destination">Destination</th>
//                     <th data-l10n-id="code">Code</th>
//                     <th data-l10n-id="number_of_calls">Number of calls</th>
//                     <th data-l10n-id="duration">Duration</th>
//                     <th data-l10n-id="amount">Amount</th>
//                     <th data-l10n-id="amount">Currency</th>
//                 </tr>
//                 </thead>
//                 <tbody>
//                 {
//                     this.props.data.map(function(datarow, j) {
//                         var destname = datarow.CLIENTDESTNAME || 'Unidentified'
//                         return (
//                             <tr key = {j}>
//                                 <td>{datarow.CLIENTDESTNAME}</td>
//                                 <td>{destname}</td>
//                                 <td>{datarow.CALLS}</td>
//                                 <td>{datarow.BILLEDSECONDS}</td>
//                                 <td>{datarow.AMOUNT}</td>
//                                 <td>{datarow.CURRENCY}</td>
//                             </tr>)
//                     }, this)
//                 }
//                 </tbody>
//             </table>
//         )
//     }
// }

export default Details;